import {
  ExternalAuthError,
  ExternalAuthFlow,
  ExternalAuthProvider,
  ExternalAuthContext,
  SocialLoginProvider,
} from '@account/account-portal/external-auth'
import { getAuthentication, setAuthContext, setExternalAuthError } from '@account/account-portal/lib'
import { User } from '@account/account-portal/types'
import { instana } from '@crystal/analytics'

import { trackSocialLoginSuccess } from '../lib/analytics/analytics'

import { AuthHandlerFactory, HandlerContext } from './handler-types'

export const createSocialLoginHandler: AuthHandlerFactory = (
  flow: ExternalAuthFlow,
  { apiClient }: HandlerContext,
) => ({
  async handleAuth(payload) {
    validateProvider(flow.provider)

    const user = await apiClient.socialLogin(payload, flow.provider as SocialLoginProvider)
    const { authContext } = getAuthentication()

    setAuthContext<ExternalAuthContext>({
      ...authContext,
      hasUser: true,
      shouldUpdateConsents: !user.session.hasPermissionsAccepted,
      authData: {
        user,
        isAuthenticated: true,
        isPersistent: user.session.isPersistent,
      },
    })

    logUserInfo(user)
    trackSocialLoginSuccess(user, flow.provider)
  },

  async handleError(err: ExternalAuthError) {
    setExternalAuthError(err.serialize())
  },
})

function validateProvider(provider: ExternalAuthProvider) {
  const allowedProviders: ExternalAuthProvider[] = ['facebook', 'google', 'apple', 'yahoo', 'kakao', 'vk', 'naver']
  if (!allowedProviders.includes(provider)) {
    throw new ExternalAuthError(`Invalid provider: ${provider}`)
  }
}

function logUserInfo(user: User) {
  instana('user', user.acid)
  instana('meta', 'isLoggedin', true)
  instana('meta', 'isPersistent', user.isPersistent as boolean)
}
